import type { SalesAndResourcesResourceLibraryContent } from '../types/SalesAndResourcesResourceLibraryContent';

export function createSalesAndResourcesResourceLibraryContentPlaceholder(): SalesAndResourcesResourceLibraryContent {
    return {
        pageTitle: { kind: 'plainText', key: '', content: '' },
        pageTitleBackgroundImage: { kind: 'image', key: '', imageUrl: '' },
    };
}
